import {Routes, UrlSegment} from '@angular/router';
import {LanguageRedirectComponent} from '@components';
import {languageGuard, redirectToLocaleGuard, supportedLangs} from '@guards';
import {AuthenticatedLayoutComponent} from '@layouts';
import {
	adminRoutes,
	assessmentRoutes,
	authRoutes,
	engagementRoutes,
	infoRoutes,
	landingRoutes,
	profileRoutes,
	requireEmailVerified
} from '@routes';

const langMatcher = (segments: UrlSegment[]) => {
	if (segments.length === 0) {
		return null;
	}
	if (supportedLangs.includes(segments[0].path)) {
		return {consumed: [segments[0]], posParams: {lang: segments[0]}};
	}
	return null;
};

export const routes: Routes = [
	{
		matcher: langMatcher,
		canActivate: [languageGuard],
		children: [
			...landingRoutes,
			{
				path: 'landing',
				redirectTo: '',
				pathMatch: 'full'
			},
			...authRoutes,
			{
				path: 'app',
				canActivate: [requireEmailVerified],
				component: AuthenticatedLayoutComponent,
				children: [
					...profileRoutes,
					...engagementRoutes.filter(route => route.canActivate?.some(guard => guard === requireEmailVerified)),
					...assessmentRoutes.filter(route => route.canActivate?.some(guard => guard === requireEmailVerified)),
					...adminRoutes
				]
			},
			// Public routes (non-authenticated)
			...assessmentRoutes.filter(route => !route.canActivate?.some(guard => guard === requireEmailVerified)),
			...engagementRoutes.filter(route => !route.canActivate?.some(guard => guard === requireEmailVerified)),
			...infoRoutes
		]
	},
	{
		path: '**',
		canActivate: [redirectToLocaleGuard],
		component: LanguageRedirectComponent
	}
];
